
































































import Vue from 'vue';
import { ECartTypeId } from '@ringana/configs';
import { IShoppingCartIndividual, IShoppingCartItem } from '@/common/interfaces/cart.interface';
import { ILimitingObject } from '@/common/interfaces/limiting.interface';
import { IProduct } from '@/common/interfaces/products.interface';
import OldCartHelper from '../../helpers/OldCartHelper';
import CookieHelper from '../../helpers/CookieHelper';
import DataLayerHelper from '../../helpers/DataLayerHelper';
import ProductListAddToCart from './ProductListAddToCart.vue';
import ProductListGridViewDetails from './ProductListGridViewDetails.vue';
import ProductListListViewDetails from './ProductListListViewDetails.vue';
import ProductHelper from '../../helpers/ProductHelper';

interface IProductListItem {
  loading: {
    addToCart: boolean;
  };
}

export default Vue.extend({
  name: `ProductListItem`,
  components: { ProductListAddToCart, ProductListGridViewDetails, ProductListListViewDetails },
  data(): IProductListItem {
    return {
      loading: {
        addToCart: false,
      },
    };
  },
  computed: {
    discountActive(): boolean {
      return !!(this.isPartner ? this.product.prices.partner.discountPercentage : this.product.prices.customer.discountPercentage);
    },
  },
  props: {
    availableCarts: {
      required: true,
      type: Array as () => IShoppingCartIndividual[],
    },
    hasMultipleCarts: {
      required: true,
      type: Boolean,
    },
    isPartner: {
      required: true,
      type: Boolean,
    },
    limiting: {
      required: true,
      type: Object as () => ILimitingObject,
    },
    mode: {
      required: true,
      type: String,
    },
    product: {
      required: true,
      type: Object as () => IProduct & { selectedAmount: number },
    },
    selectedCartId: {
      required: true,
      validator: prop => Number.isInteger(prop) || prop === null,
    },
  },
  methods: {
    async addItemToCartAndUpdate(): Promise<void> {
      this.loading.addToCart = true;

      const cartId = this.product.isMerchandise ? CookieHelper.getPersonalUseCartId() : this.selectedCartId; // to avoid the cartId changing before checking for merch overlay

      const body = {
        amount: 1,
        matchcode: this.product.matchcode,
      };
      // setting cart type to "EIGENBEDARF" here seems wrong, however it doesn't break anything since FREMD and EIGENBEDARF do the same
      const addItemResponse = await OldCartHelper.addItemToCart(body, cartId, ECartTypeId.PERSONAL_USE);

      const atcProducts = {
        id: this.product.matchcode,
        name: this.product.title,
        price: ProductHelper.getPriceUnformatted(this.isPartner, this.product.prices),
        quantity: this.product.selectedAmount || 1,
      };
      DataLayerHelper.setProductInfoOnAddToCartToGtm(atcProducts);

      this.loading.addToCart = false;

      if(addItemResponse.cartContentId) {
        const shoppingCart = (addItemResponse.data.shoppingCarts as IShoppingCartIndividual[]).find(cart => cart.cartId === cartId);
        const item = shoppingCart?.items.find((cartItem: IShoppingCartItem): boolean => cartItem.cartContentId === addItemResponse.cartContentId);
        this.$emit(`open:merchandise-overlay`, item);
      }
    },
  },
});
